import { render, staticRenderFns } from "./ContactPanel.vue?vue&type=template&id=481bade4&scoped=true&"
import script from "./ContactPanel.vue?vue&type=script&lang=js&"
export * from "./ContactPanel.vue?vue&type=script&lang=js&"
import style0 from "./ContactPanel.vue?vue&type=style&index=0&id=481bade4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481bade4",
  null
  
)

export default component.exports